const CHILL_HITS_LYRICS = {
    'troi-giau-troi-mang-di': [
        { start: 18, end: 20, text: `Sương mờ che khuất đồi` },
        { start: 20, end: 23, text: `Đêm nào em cũng ngồi` },
        { start: 23, end: 29, text: `Lúc xa anh em thật sự chỉ nhớ mãi thôi` },
        { start: 29, end: 31, text: `Tuy rằng mới bắt đầu` },
        { start: 31, end: 34, text: `Tình yêu này như phép màu` },
        { start: 34, end: 40, text: `Cứ cho là vì mình chỉ mới nói hẹn hò thôi` },
        { start: 40, end: 42, text: `Nhưng vì anh quá tuyệt!` },
        { start: 42, end: 44, text: `Nhìn đâu thì em cũng duyệt` },
        { start: 44, end: 50, text: `Cứ như đôi mình nợ nhau từ lâu quá nhiều` },
        { start: 50, end: 55, text: `Đâu phải ai cũng hiểu, rằng khi mình nhớ quá nhiều` },
        { start: 55, end: 59, text: `Chẳng thể tập trung làm điều gì hết nữa` },
        { start: 59, end: 61, text: `Xa là sẽ nhớ ngay` },
        { start: 61, end: 64, text: `Xa là khóe mắt cay` },
        { start: 64, end: 69, text: `Xa là chỉ thấy em anh cười đôi mắt lim dim` },
        { start: 69, end: 72, text: `Xa là em sẽ tìm` },
        { start: 72, end: 75, text: `Sẽ nhìn anh cho dù ngày hay đêm` },
        { start: 75, end: 80, text: `Giá như ngay bây giờ được gặp nhau trước thềm` },
        { start: 80, end: 82, text: `Thôi thì chỉ ướt mi` },
        { start: 82, end: 85, text: `Do là nhớ quá đi` },
        { start: 85, end: 90, text: `Chẳng hiểu sao trước kia ông trời lại giấu anh đi` },
        { start: 90, end: 93, text: `Thôi thì chẳng có gì` },
        { start: 93, end: 96, text: `Do là em yêu nhiều, tại em đó` },
        { start: 96, end: 106, text: `Cứ coi như mây chẳng nhìn lời nói gió bay` },
        { start: 112, end: 114, text: `Dù ai nói` },
        { start: 114, end: 122, text: `Rằng đời này chúng ta thuộc về nhau tình yêu trăng sáng sao băng` },
        { start: 122, end: 127, text: `Con đường đầy lá rơi, nơi này mình từng đi` },
        { start: 127, end: 130, text: `Nhưng tiếc là` },
        { start: 130, end: 133, text: `Chẳng thấy anh đâu` },
        { start: 133, end: 135, text: `Dù ai nói` },
        { start: 135, end: 143, text: `Tình em đây mãi luôn ở bên anh chở che mưa nắng bão giông` },
        { start: 143, end: 148, text: `Gió lạnh đừng có lo, em ở ngay sau lưng` },
        { start: 148, end: 153, text: `Vẫn biết yêu thương làm con tim sẽ nhớ nhung` },
        { start: 153, end: 155, text: `Xa là sẽ nhớ ngay` },
        { start: 155, end: 158, text: `Xa là khóe mắt cay` },
        { start: 158, end: 163, text: `Xa là chỉ thấy em anh cười đôi mắt lim dim` },
        { start: 163, end: 166, text: `Xa là em sẽ tìm` },
        { start: 166, end: 169, text: `Sẽ nhìn anh cho dù ngày hay đêm` },
        { start: 169, end: 173, text: `Giá như ngay bây giờ được gặp nhau trước thềm` },
        { start: 173, end: 176, text: `Thôi thì chỉ ướt mi` },
        { start: 176, end: 179, text: `Do là nhớ quá đi` },
        { start: 179, end: 184, text: `Chẳng hiểu sao trước kia ông trời lại giấu anh đi` },
        { start: 184, end: 186, text: `Thôi thì chẳng có gì` },
        { start: 186, end: 190, text: `Do là em yêu nhiều, tại em đó` },
        { start: 190, end: 197, text: `Cứ coi như mây chẳng nhìn lời nói gió bay` },
        { start: 197, end: 199, text: `Con đường đầy nắng hoa` },
        { start: 199, end: 202, text: `Mà sao giờ anh đã xa` },
        { start: 202, end: 207, text: `Em ngồi đây khóc to do trời lại lấy anh đi` },
        { start: 207, end: 230, text: `Yêu là vì những gì` },
        { start: 230, end: 234, text: `Sao phải buông khi chẳng thể rời xa` },
        { start: 234, end: 238, text: `Gió mang cơn mưa về làm lòng ai não nề` },
        { start: 238, end: 240, text: `Thôi thì chỉ ướt mi` },
        { start: 240, end: 243, text: `Do là nhớ quá đi` },
        { start: 243, end: 249, text: `Chẳng hiểu sao trước kia ông trời lại giấu anh đi` },
        { start: 249, end: 251, text: `Thôi thì chẳng có gì` },
        { start: 251, end: 255, text: `Do là em yêu nhiều, tại em đó` },
        { start: 255, end: 265, text: `Cứ coi như mây chẳng nhìn lời nói gió bay` },
    ],
    'em-la-hoang-hon': [
        { start: 9, end: 14, text: `Má của em hồng tựa cành thắm, mắt của em cùng bờ môi cong` },
        { start: 14, end: 19, text: `Đã làm anh cả đêm thức trắng nghĩ về em và chuуện tình trăm năm` },
        { start: 19, end: 24, text: `Ϲó tình уêu nào không đầу nắng, có hoàng hôn nào không xa xăm` },
        { start: 24, end: 28, text: `Kéo màn đêm về trong u tối, tắt đèn thôi and Ɩ miss уou` },
        { start: 28, end: 33, text: `Là уêu 2 ta quên đi bao lần nghi ngờ để sầu giờ vươn trên hàng mi` },
        {
            start: 33,
            end: 37,
            text: `Babу quaу ngoắt người đi, đôi taу ta chẳng còn chi giâу phút nhiệm màu oh girl Ɩ can’t see`,
        },
        { start: 37, end: 43, text: `Tim anh như nắng đợi mưa, nhớ ngàу xưa nghĩ về em bờ môi cong` },
        { start: 43, end: 47, text: `Mong уêu thương 2 ta được sáng đèn, mọi muộn phiền tan đi không rối ren` },
        { start: 47, end: 52, text: `Vì khi уêu 2 ta tung baу cùng nhịp và câu ca anh trao em tối qua` },
        { start: 52, end: 57, text: `Bae pulled up pulled up pulled up pulled up pulled up pulled up` },
        { start: 57, end: 61, text: `Và gió trên cao anh đâу sẽ ra sao, trao em tinh tú trên cao và trông mong` },
        { start: 61, end: 67, text: `Bae pulled up pulled up pulled up pulled up pulled up pulled up` },
        { start: 67, end: 72, text: `Ϲha cha cha vì nàng đẹp hơn bất kì ai` },
        { start: 72, end: 77, text: `La la la nụ cười em be like sunshine` },
        { start: 77, end: 82, text: `Ϲha cha cha fall in love with уou tonight` },
        { start: 82, end: 89, text: `La la la sippin wine and feeling fine` },
        { start: 106, end: 108, text: `Ѕaу em từ cái nhìn đầu tiên` },
        { start: 108, end: 110, text: `Không cần makeup trong vẫn rất là duуên` },
        { start: 110, end: 113, text: `Ɲụ cười hoàn hảo cùng má lúm đồng tiền` },
        { start: 113, end: 115, text: `Đôi môi xinh xắn làm thế giới đảo điên` },
        { start: 115, end: 120, text: `Và anh saу em rồi đấу, chỉ muốn được bên em dù là cho một vài giâу` },
        { start: 120, end: 125, text: `Một chiếc lâu đài mà đôi ta cùng saу, em cũng biết mà phải không babe` },
        { start: 125, end: 129, text: `Vẫn chờ đợi em dù là có bao lâu, tình cảm trao em anh vẫn luôn cất giấu` },
        { start: 129, end: 135, text: `Muốn em là của riêng anh mặc dù anh biết ích kỷ đó là rất xấu` },
        { start: 135, end: 140, text: `Anh thì đã lâu chả có thương ai, đêm ngủ hơi muộn sáng dậу vương vai` },
        { start: 140, end: 144, text: `Ϲó rất nhiều điều anh muốn có, đó là có em ở trong tương lai` },
        { start: 144, end: 149, text: `Ϲha cha cha vì nàng đẹp hơn bất kì ai` },
        { start: 149, end: 154, text: `La la la nụ cười em be like sunshine` },
        { start: 154, end: 158, text: `Ϲha cha cha fall in love with уou tonight` },
        { start: 158, end: 166, text: `La la la sippin wine and feeling fine` },
        { start: 182, end: 187, text: `Không còn thương nhớ em giờ bên ai` },
        { start: 187, end: 192, text: `Đã từng уêu con tim cùng nhịp, mà giờ người đi không quan tâm ai đúng sai` },
        { start: 192, end: 197, text: `Bước đường tương lai chỉ còn phôi phai` },
        { start: 197, end: 205, text: `Ϲhẳng còn anh đưa em về nhà, mà một mình em đang loaу hoaу ở dưới mưa` },
        { start: 205, end: 215, text: `la ...lá..la... Vì ai...vì ai....` },
        { start: 215, end: 222, text: `la ...lá..la... Vì ai...vì ai....` },
    ],
    'vi-yeu-cu-dam-dau': [
        { start: 16, end: 18, text: `Qua nỗi sầu đêm nay` },
        { start: 18, end: 20, text: `Trăng gối đầu lên mây` },
        { start: 20, end: 24, text: `Thêm chút rượu và men cuốn muộn phiền đi để tình thêm say` },
        { start: 24, end: 26, text: `Đôi mắt buồn sâu cay` },
        { start: 26, end: 27, text: `Chan chứa tình lâu nay` },
        { start: 27, end: 32, text: `Oh boy` },
        { start: 32, end: 34, text: `Không biết ở nơi đâu` },
        { start: 34, end: 36, text: `Không biết được bao lâu` },
        { start: 36, end: 40, text: `Chỉ muốn cùng anh đi đến tận cùng nơi đất trời thâm sâu` },
        { start: 40, end: 43, text: `Ooh-oh-oh-oh-oh` },
        { start: 43, end: 45, text: `Vì yêu cứ đâm đầu (Cứ đâm đầu)` },
        { start: 45, end: 49, text: `Cứ đâm đầu (Cứ đâm đầu)` },
        { start: 49, end: 53, text: `Ngay lúc nhìn, ngay lúc nhìn, ngay lúc nhìn, ngay lúc nhìn anh đôi phút` },
        { start: 53, end: 56, text: `Tim đã vội, tim đã vội, tim đã vội, tim đã vội hơn đôi chút` },
        { start: 56, end: 59, text: `Sorry em chẳng biết làm sao` },
        { start: 59, end: 61, text: `Để thì giờ trôi phí là bao` },
        { start: 61, end: 64, text: `Oh-uh-oh, oh-oh` },
        { start: 64, end: 68, text: `Em muốn được trói chặt trong vòng tay của anh` },
        { start: 68, end: 72, text: `Em muốn được nghe từng hơi thở đang bủa quanh` },
        { start: 72, end: 75, text: `Xin hãy đừng, hãy đừng, hãy đừng, hãy đừng` },
        { start: 75, end: 79, text: `Để em đợi (Yeah)` },
        { start: 79, end: 80, text: `Ay` },
        { start: 80, end: 82, text: `Chạm lên bờ môi của em đỏ âu` },
        { start: 82, end: 84, text: `Trò chuyện thật nhiều để cho rõ nhau` },
        { start: 84, end: 86, text: `Chúng ta hoang dại như là cỏ lau` },
        { start: 86, end: 87, text: `Bỏ tiền bỏ bạc chứ không bỏ nhau` },
        { start: 87, end: 89, text: `Anh sẽ nói cho em nghe những điều mà anh ấp ủ` },
        { start: 89, end: 91, text: `Anh hy vọng lời ca này vỗ về em trong giấc ngủ` },
        { start: 91, end: 93, text: `Anh cũng muốn em biết anh vốn không phải là thiếu gia` },
        { start: 93, end: 95, text: `Những ngày em về trong đời anh nhất định trải chiếu hoa` },
        { start: 95, end: 97, text: `Qua nỗi sầu đêm nay` },
        { start: 97, end: 99, text: `Trăng gối đầu lên mây` },
        { start: 99, end: 104, text: `Thêm chút rượu và men cuốn muộn phiền đi để tình thêm say` },
        { start: 104, end: 106, text: `Đôi mắt buồn sâu cay` },
        { start: 106, end: 107, text: `Chan chứa tình lâu nay` },
        { start: 107, end: 111, text: `Oh boy` },
        { start: 111, end: 114, text: `Không biết ở nơi đâu` },
        { start: 114, end: 116, text: `Không biết được bao lâu` },
        { start: 116, end: 120, text: `Chỉ muốn cùng anh đi đến tận cùng nơi đất trời thâm sâu` },
        { start: 120, end: 123, text: `Ooh-oh-oh-oh-oh` },
        { start: 123, end: 125, text: `Vì yêu cứ đâm đầu (Cứ đâm đầu)` },
        { start: 125, end: 128, text: `Cứ đâm đầu (Cứ đâm đầu) (Just, just, just)` },
        { start: 128, end: 130, text: `Ohhh` },
        { start: 130, end: 132, text: `Cứ lãng đãng trôi như làn mây trắng` },
        { start: 132, end: 133, text: `Chẳng cần lo nghĩ nhiều` },
        { start: 133, end: 137, text: `Chỉ cần em biết điều` },
        { start: 137, end: 143, text: `Và ohh khi trăng lên cao em sẽ là ngọn gió cuốn anh feel` },
        { start: 143, end: 146, text: `Cầm chặt tay và nâng ly cùng em nhé` },
        { start: 146, end: 148, text: `Cho đêm này thêm hé` },
        { start: 148, end: 150, text: `Chơi vơi trong vòng tay anh` },
        { start: 150, end: 152, text: `Hãy đặt tên em là em bé` },
        { start: 152, end: 157, text: `Oh-oh, vì đường về còn xa lắm em ơi thấy không mưa còn rơi (Mưa còn rơi)` },
        { start: 157, end: 160, text: `Qua đêm nay rồi anh sẽ đưa em về` },
        { start: 160, end: 161, text: `Anh ơi, em ơi` },
        { start: 161, end: 164, text: `Say, say, ai sẽ đưa em về? (Ối giời)` },
        { start: 164, end: 166, text: `Em ơi, không may, đêm nay` },
        { start: 166, end: 167, text: `Chưa muốn đưa em về` },
        { start: 167, end: 170, text: `Don’t be lonely tonight` },
        { start: 170, end: 176, text: `Baby i’m so high on you` },
        { start: 176, end: 178, text: `Qua nỗi sầu đêm nay` },
        { start: 178, end: 180, text: `Trăng gối đầu lên mây` },
        { start: 180, end: 184, text: `Thêm chút rượu và men cuốn muộn phiền đi để tình thêm say (Min)` },
        { start: 184, end: 186, text: `Đôi mắt buồn sâu cay (JustaTee)` },
        { start: 186, end: 187, text: `Chan chứa tình lâu nay` },
        { start: 187, end: 192, text: `Oh boy (Ya)` },
        { start: 192, end: 194, text: `Không biết ở nơi đâu (Nơi đâu)` },
        { start: 194, end: 196, text: `Không biết được bao lâu (Bao lâu)` },
        {
            start: 196,
            end: 200,
            text: `Chỉ muốn cùng anh đi đến tận cùng nơi đất trời thâm sâu (Nơi đất trời thâm sâu)`,
        },
        { start: 200, end: 203, text: `Ooh-oh-oh-oh-oh (Baby)` },
        { start: 203, end: 206, text: `Vì yêu cứ đâm đầu (Sao em cứ đâm đầu) (Cứ đâm đầu)` },
        { start: 206, end: 209, text: `Cứ đâm đầu (Sao em cứ đâm đầu) (Cứ đâm đầu)` },
        { start: 209, end: 211, text: `Just, just, just, just-` },
        { start: 211, end: 219, text: `Ay, Đen Vâu` },
    ],
    'anh-a': [
        { start: 31, end: 37, text: `Anh à, tối qua anh có ngủ ngon không?` },
        { start: 37, end: 45, text: `Ϲòn em thì ôm mãi, chiếc hình anh` },
        { start: 45, end: 51, text: `Anh à, sáng naу anh có ngủ thêm không?` },
        { start: 51, end: 58, text: `Ϲòn em thì đang viết cho anh bài ca đầu tiên` },
        { start: 58, end: 64, text: `Xa nhau vài tiếng, ngỡ như năm` },
        { start: 64, end: 71, text: `Bên em trăng khuуết, hóa trăng rằm` },
        { start: 71, end: 75, text: `Bài tình ca đầu tiên cho anh` },
        { start: 75, end: 78, text: `Tôi xin viết dành riêng cho em` },
        { start: 78, end: 85, text: `Mong sẽ đến nơi anh chút bình уên nhẹ` },
        { start: 85, end: 88, text: `Bài tình ca đầu tiên cho anh` },
        { start: 88, end: 92, text: `Tôi xin gói hết những уêu thương nàу` },
        { start: 92, end: 101, text: `Mong mãi mãi về sau, bên nhau` },
        { start: 101, end: 107, text: `Anh à, tối qua anh có ngủ ngon không` },
        { start: 107, end: 115, text: `Ϲòn em thì nghe mãi mấу bài ca của anh` },
        { start: 115, end: 121, text: `Anh à, sáng naу mâу cứ vờn nơi đâу` },
        { start: 121, end: 128, text: `Làm kéo dài, dài mãi cơn mơ về anh` },
        { start: 128, end: 135, text: `Xa nhau vài tiếng, ngỡ như năm` },
        { start: 135, end: 142, text: `Bên em trăng khuуết, hóa trăng rằm` },
        { start: 142, end: 145, text: `Bài tình ca đầu tiên cho anh` },
        { start: 145, end: 149, text: `Tôi xin viết dành riêng cho em` },
        { start: 149, end: 155, text: `Mong sẽ đến nơi anh chút bình уên nhẹ` },
        { start: 155, end: 158, text: `Bài tình ca đầu tiên cho anh` },
        { start: 158, end: 162, text: `Tôi xin gói hết những уêu thương nàу` },
        { start: 162, end: 170, text: `Mong mãi mãi về sau, bên nhau` },
        { start: 183, end: 187, text: `Just want to be with уou` },
        { start: 187, end: 191, text: `Mу heart is now for уou` },
        { start: 191, end: 194, text: `Just want to be with уou` },
        { start: 194, end: 197, text: `The sun will shine for two` },
        { start: 197, end: 201, text: `Just want to be with уou` },
        { start: 201, end: 204, text: `Mу heart is now for уou` },
        { start: 204, end: 208, text: `Just want to be with уou` },
        { start: 208, end: 218, text: `The sun will shine for two` },
    ],
    'can-gi-hon': [
        { start: 21, end: 24, text: `Nơi tin yêu nhiệm màu` },
        { start: 24, end: 27, text: `Từng nụ hôn trao như tình đầu` },
        { start: 27, end: 29, text: `Anh đưa tay nguyện cầu` },
        { start: 29, end: 32, text: `Gửi về em tiếng ca chân thành (rất chân thành)` },
        { start: 32, end: 34, text: `Xa em như cây lìa cành` },
        { start: 34, end: 38, text: `Thương em nắng mưa cũng đành` },
        { start: 38, end: 40, text: `Dù chỉ là ngày chờ đêm trông` },
        { start: 40, end: 43, text: `Baby can you feel me yeah yeah` },
        { start: 43, end: 46, text: `Có ước muốn thân ta tan theo gió` },
        { start: 46, end: 48, text: `Kéo bước theo anh rong chơi` },
        { start: 48, end: 51, text: `Có ước muốn ngôi sao trong đêm tối` },
        { start: 51, end: 53, text: `Rẽ lối bên anh khắp nơi` },
        { start: 53, end: 55, text: `Có ước muốn` },
        { start: 55, end: 56, text: `Anh chôn sâu` },
        { start: 56, end: 57, text: `Những nỗi nhớ` },
        { start: 57, end: 59, text: `Tan đi đâu` },
        { start: 59, end: 61, text: `Tàn theo những giấc mơ hững hờ` },
        { start: 61, end: 63, text: `Cần gì hơn khi đã có em` },
        { start: 63, end: 67, text: `Cần gì hơn babe cần gì hơn` },
        { start: 67, end: 69, text: `Cần gì hơn khi đã có em` },
        { start: 69, end: 72, text: `Cần gì hơn babe cần gì hơn` },
        { start: 72, end: 74, text: `Cần gì hơn khi đã có em` },
        { start: 74, end: 77, text: `Cần gì hơn babe cần gì hơn` },
        { start: 77, end: 79, text: `Cần gì hơn khi đã có em` },
        { start: 79, end: 84, text: `Cần gì hơn babe cần gì hơn babe` },
        { start: 84, end: 87, text: `I see you there I see you everywhere` },
        { start: 87, end: 90, text: `In my mind even in my dreams` },
        { start: 90, end: 92, text: `Who loves you sorry I don’t care` },
        { start: 92, end: 95, text: `Cause I know who is in your heart` },
        { start: 95, end: 97, text: `Chim muông bay tìm ngọt ngào từ mưa giông` },
        { start: 97, end: 100, text: `Cho đêm nay đừng dài hơn những nhớ mong` },
        { start: 100, end: 105, text: `Giữ lấy ngón tay đan vào nhau ai biết mai về sau anh với em còn không` },
        { start: 105, end: 107, text: `Có ước muốn thân ta tan theo gió` },
        { start: 107, end: 110, text: `Kéo bước theo anh rong chơi` },
        { start: 110, end: 113, text: `Có ước muốn ngôi sao trong đêm tối` },
        { start: 113, end: 115, text: `Rẽ lối bên anh khắp nơi` },
        { start: 115, end: 117, text: `Có ước muốn` },
        { start: 117, end: 118, text: `Anh chôn sâu` },
        { start: 118, end: 119, text: `Những nỗi nhớ` },
        { start: 119, end: 121, text: `Tan đi đâu` },
        { start: 121, end: 123, text: `Tàn theo những giấc mơ hững hờ` },
        { start: 123, end: 125, text: `Cần gì hơn khi đã có em` },
        { start: 125, end: 128, text: `Cần gì hơn babe cần gì hơn` },
        { start: 128, end: 130, text: `Cần gì hơn khi đã có em` },
        { start: 130, end: 133, text: `Cần gì hơn babe cần gì hơn` },
        { start: 133, end: 135, text: `Cần gì hơn khi đã có em` },
        { start: 135, end: 138, text: `Cần gì hơn babe cần gì hơn` },
        { start: 138, end: 141, text: `Cần gì hơn khi đã có em` },
        { start: 141, end: 146, text: `Cần gì hơn babe cần gì hơn babe` },
        { start: 146, end: 148, text: `Đã có anh cần gì hơn` },
        { start: 148, end: 151, text: `Đã có em cần gì hơn` },
        { start: 151, end: 154, text: `Và ta đã có nhau cần gì hơn` },
        { start: 154, end: 156, text: `I need you only you` },
        { start: 156, end: 158, text: `Đã có anh cần gì hơn` },
        { start: 158, end: 161, text: `Đã có em cần gì hơn` },
        { start: 161, end: 170, text: `Vậy khi đã có nhau cần gì hơn nah` },
        { start: 170, end: 172, text: `Cần gì hơn khi đã có em` },
        { start: 172, end: 175, text: `Cần gì hơn babe cần gì hơn` },
        { start: 175, end: 177, text: `Cần gì hơn khi đã có em` },
        { start: 177, end: 180, text: `Cần gì hơn babe cần gì hơn` },
        { start: 180, end: 182, text: `Cần gì hơn khi đã có em` },
        { start: 182, end: 185, text: `Cần gì hơn babe cần gì hơn` },
        { start: 185, end: 188, text: `Cần gì hơn khi đã có em` },
        { start: 188, end: 196, text: `Cần gì hơn babe cần gì hơn babe` },
    ],
    'co-em-cho': [
        { start: 11, end: 17, text: `Từ lần đầu tiên ta đi bên nhau em đã biết tim mình đánh rơi rồi` },
        { start: 17, end: 24, text: `Từ lần đầu tiên môi hôn trao nhau em đã biết không thể yêu thêm ai` },
        { start: 24, end: 27, text: `Cách anh cười cong môi` },
        { start: 27, end: 30, text: `Cách anh lặng lẽ ngồi` },
        { start: 30, end: 35, text: `Ngồi nhìn bóng tối lặng thầm thời gian trôi` },
        {
            start: 35,
            end: 41,
            text: `Người đàn ông em yêu đôi khi có những phút giây yếu đuối không ngờ (phút giây yếu đuối không ngờ)`,
        },
        { start: 41, end: 48, text: `Ngoài kia nếu có khó khăn quá về nhà anh nhé, có em chờ` },
        { start: 48, end: 51, text: `Có môi mềm thơm thơm` },
        { start: 51, end: 54, text: `Có dư vị mỗi bữa cơm` },
        { start: 54, end: 58, text: `Xuân hạ thu đông đều có em chờ` },
        { start: 58, end: 62, text: `Yo, có định mệnh nào bao nhiêu lâu anh đã ao ước` },
        { start: 62, end: 65, text: `Có vần thơ nào bao nhiêu đêm anh đi tìm hoài (tìm hoài)` },
        { start: 65, end: 67, text: `Và nếu khoảng cách là một nghìn bước` },
        { start: 67, end: 69, text: `Thì em chỉ cần bước một bước` },
        { start: 69, end: 72, text: `Anh sẽ bước 999 bước còn lại` },
        { start: 72, end: 74, text: `Bước về phía em` },
        { start: 74, end: 77, text: `Nơi mà em thấy nắng mai` },
        { start: 77, end: 80, text: `Nơi con tim anh biết yên bình` },
        { start: 80, end: 83, text: `Và mong thế thôi, that's right` },
        { start: 83, end: 89, text: `Tình yêu là những ánh sáng lấp lánh đèn vàng thắp lên bên ô cửa nhỏ` },
        { start: 89, end: 96, text: `Tình yêu là những dịu êm từng đêm mình cùng ăn tối và nghe mưa rơi` },
        { start: 96, end: 102, text: `Biết sẽ có những lúc trái tim đau đớn khôn nguôi` },
        { start: 102, end: 107, text: `Vẫn yêu và yêu và yêu thế thôi` },
        { start: 107, end: 109, text: `Và lần đầu tiên con tim như rụng rời` },
        { start: 109, end: 111, text: `Lần đầu tiên anh không nói nên lời` },
        { start: 111, end: 112, text: `Giấc mơ nào có đâu xa` },
        { start: 112, end: 114, text: `Tình yêu nơi đâu có hai ta` },
        { start: 114, end: 115, text: `Nơi tóc em quá mượt mà` },
        { start: 115, end: 117, text: `Con phố xưa đón đưa và` },
        { start: 117, end: 120, text: `(Em sẽ yêu mãi anh tháng năm dài)` },
        { start: 120, end: 122, text: `Bao nhiêu tháng ngày tăm tối` },
        { start: 122, end: 123, text: `Khi mà có em ngày qua` },
        { start: 123, end: 125, text: `Nỗi buồn cũng phải buông trôi` },
        { start: 125, end: 126, text: `Khi giờ ta có em và` },
        { start: 126, end: 127, text: `Một ngàn khúc ca quanh ta` },
        { start: 127, end: 129, text: `Xin em đừng giận anh nhá!` },
        { start: 129, end: 131, text: `Bởi vì đôi khi anh là` },
        {
            start: 131,
            end: 137,
            text: `Người đàn ông em yêu đôi khi có những phút giây yếu đuối không ngờ (phút giây yếu đuối không ngờ)`,
        },
        { start: 137, end: 144, text: `Ngoài kia nếu có khó khăn quá về nhà anh nhé, có em chờ` },
        { start: 144, end: 147, text: `Có môi mềm thơm thơm` },
        { start: 147, end: 150, text: `Có dư vị mỗi bữa cơm` },
        { start: 150, end: 155, text: `Xuân hạ thu đông đều có em chờ` },
        { start: 155, end: 161, text: `Tình yêu là những ánh sáng lấp lánh đèn vàng thắp lên bên ô cửa nhỏ` },
        { start: 161, end: 168, text: `Tình yêu là những dịu êm từng đêm mình cùng ăn tối và nghe mưa rơi` },
        { start: 168, end: 174, text: `Biết sẽ có những lúc trái tim đau đớn khôn nguôi` },
        { start: 174, end: 180, text: `Vẫn yêu và yêu và yêu thế thôi` },
        { start: 180, end: 182, text: `What's love?` },
        { start: 182, end: 183, text: `Can you feel it?` },
        { start: 183, end: 185, text: `What's love?` },
        { start: 185, end: 186, text: `Can you feel it?` },
        { start: 186, end: 193, text: `What's love?` },
        { start: 193, end: 194, text: `What's love?` },
        { start: 194, end: 195, text: `Just tell me baby` },
        { start: 195, end: 197, text: `What's love?` },
        { start: 197, end: 198, text: `Just tell me baby` },
        { start: 198, end: 203, text: `What's love?` },
        { start: 203, end: 209, text: `Tình yêu là những ánh sáng lấp lánh đèn vàng thắp lên bên ô cửa nhỏ` },
        { start: 209, end: 216, text: `Tình yêu là những dịu êm từng đêm mình cùng ăn tối và nghe mưa rơi` },
        { start: 216, end: 222, text: `Biết sẽ có những lúc trái tim đau đớn khôn nguôi` },
        { start: 222, end: 230, text: `Vẫn yêu và yêu và yêu thế thôi` },
    ],
    'em-tam-di-vang-khi-anh-thuc-giac': [
        { start: 27, end: 33, text: `Anh đừng bỏ bữa nữa, thôi chờ đợi nhung nhớ` },
        { start: 33, end: 38, text: `Nhắm mắt gọi tên nhau nghe tiếng em dỗ dành` },
        { start: 38, end: 43, text: `Yêu trong từng cơn mơ, xin anh đừng tan vỡ` },
        { start: 43, end: 49, text: `Em chỉ tạm đi vắng khi anh thức giấc thôi mà` },
        { start: 49, end: 54, text: `Chỉ cần người gọi tên, màn đêm em hiện lên` },
        { start: 54, end: 60, text: `Bàn chân hồng e ấp nấp sau tấm áo vô hình` },
        { start: 60, end: 67, text: `Chỉ cần người gọi tên màn đêm em hiện lên` },
        { start: 67, end: 70, text: `"I will be there for you"` },
        { start: 70, end: 72, text: `Ah, hah-hah-ah` },
        { start: 72, end: 75, text: `Ah, hah-hah-ah` },
        { start: 75, end: 78, text: `Ah, hah-hah-ah` },
        { start: 78, end: 81, text: `Ah, hah-hah-ah` },
        { start: 81, end: 83, text: `Ah, hah-hah-ah` },
        { start: 83, end: 86, text: `Ah, hah-hah-ah` },
        { start: 86, end: 89, text: `Ah, hah-hah-ah` },
        { start: 89, end: 92, text: `Ah, hah-hah-ah` },
        { start: 92, end: 98, text: `Thêm một ngày trôi qua, ký ức chẳng phôi pha` },
        { start: 98, end: 103, text: `Ông mặt trời kéo nắng sưởi ấm anh thôi giá lạnh` },
        { start: 103, end: 109, text: `Yêu trong từng cơn mơ, xin anh đừng tan vỡ` },
        { start: 109, end: 114, text: `Em chỉ tạm đi vắng khi anh thức giấc thôi mà` },
        { start: 114, end: 120, text: `Chỉ cần người gọi tên, màn đêm em hiện lên` },
        { start: 120, end: 125, text: `Bàn chân hồng e ấp nấp sau tấm áo vô hình` },
        { start: 125, end: 132, text: `Chỉ cần người gọi tên màn đêm em hiện lên` },
        { start: 132, end: 138, text: `"I will be there for you (Ah, hah-hah-ah)"` },
        { start: 138, end: 143, text: `I will be there for you (Ah, hah-hah-ah) ` },
        { start: 143, end: 148, text: `I will be there for you (Ah, hah-hah-ah) ` },
        { start: 148, end: 154, text: `I will be there for you (Ah, hah-hah-ah) ` },
        { start: 154, end: 158, text: `I will be there for you` },
        { start: 158, end: 164, text: `Chỉ cần người gọi tên (ah-hah), màn đêm em hiện lên (ah-hah)` },
        { start: 164, end: 169, text: `Bàn chân hồng e ấp nấp sau tấm áo vô hình` },
        { start: 169, end: 176, text: `Chỉ cần người gọi tên (ah-hah-ah), màn đêm em hiện lên (ah)` },
        { start: 176, end: 181, text: `"I will be there for you (Ah, hah-hah-ah) "` },
        { start: 181, end: 187, text: `I will be there for you (hah-hah-ah) ` },
        { start: 187, end: 192, text: `I will be there for you (Ah, hah-hah-ah) ` },
        { start: 192, end: 198, text: `I will be there for you (hah-hah-ah) ` },
        { start: 198, end: 208, text: `I will be there for you (Ah, hah-hah-ah) ` },
    ],
    'co-em': [
        { start: 8, end: 15, text: `Từ ngày hôm qua khung trời bên cửa sổ đẹp lung linh bên ngàn tia nắng` },
        { start: 15, end: 21, text: `Để ngày hôm nay khung trời riêng mang trong mình anh thêm em đến bên đời` },
        { start: 21, end: 23, text: `Bởi vì khi nắng vẫn còn rơi` },
        { start: 23, end: 25, text: `Khi bóng tối còn chơi vơi` },
        { start: 25, end: 27, text: `Khi ánh mắt nghỉ ngơi` },
        { start: 27, end: 28, text: `Thao thức tháng ngày trôi` },
        { start: 28, end: 30, text: `Là khi em đến giấc ngủ say` },
        { start: 30, end: 32, text: `Thao thức bỗng chợt theo mây` },
        { start: 32, end: 35, text: `Cuốn theo đơn côi biết bao ngày` },
        { start: 35, end: 37, text: `Because now you are my bae` },
        { start: 37, end: 39, text: `'Cause you're now my bae` },
        { start: 39, end: 41, text: `'Cause you're now my bae` },
        { start: 41, end: 42, text: `'Cause you're now my babe` },
        { start: 42, end: 44, text: `Because now you are my bae` },
        { start: 44, end: 46, text: `'Cause you're now my babe` },
        { start: 46, end: 48, text: `'Cause it's you, ooh-ooh-ooh` },
        { start: 48, end: 52, text: `Là bởi vì có em, mây thay màu` },
        { start: 52, end: 56, text: `Đẹp tựa bao giấc mơ chôn sâu anh từng giấu` },
        { start: 56, end: 60, text: `Bởi vì là chính em mang u sầu` },
        { start: 60, end: 64, text: `Gửi vào làn gió bay xa để khung trời anh giữ sẽ có thêm màu xanh` },
        { start: 64, end: 68, text: `Ooh yeah, thấy em nhìn lướt khi vào show, biết ngay là cá đã cắn câu (xời)` },
        {
            start: 68,
            end: 71,
            text: `Ooh yeah, có ngay cả squad đang nhìn thâu, anh đoán là không ai cưa được đâu (no)`,
        },
        { start: 71, end: 75, text: `Ooh yeah, baby girl anh xin số, xong anh khuyến mãi một lượt flow` },
        {
            start: 75,
            end: 78,
            text: `Anh đón em buổi sáng, em cho anh chờ lâu, xung quanh khu em nguyên một hàng dâu`,
        },
        { start: 78, end: 80, text: `Em ra cười ngại, không nói một câu` },
        { start: 80, end: 82, text: `Anh bảo thoải mái đi với ai sao phải giấu` },
        {
            start: 82,
            end: 85,
            text: `Tặng ngay cho em bông hoa mà trông xấu nhưng phải thế nó mới tôn khuôn mặt xinh của em, woah`,
        },
        { start: 85, end: 87, text: `Tặng em cà phê, cà phê pha` },
        { start: 87, end: 89, text: `Em thích bạc xỉu, tiền anh bún trả` },
        {
            start: 89,
            end: 92,
            text: `Cảm thấy cá hồi đợt vừa rồi hơi suy, người anh như tá lả khi bồ cũ nó trà đá`,
        },
        { start: 92, end: 95, text: `Nên là lên Đà Lạt food tour cho nó chill đê, eh` },
        { start: 95, end: 97, text: `Visa lấy ra tiêu đê, eh` },
        { start: 97, end: 98, text: `Em bảo anh là yêu ghê` },
        { start: 98, end: 100, text: `Book con Airbnb nhìn thì siêu mê` },
        { start: 100, end: 101, text: `Mặc ngay con áo phao xong đi ngắm sao` },
        { start: 101, end: 103, text: `Vặn ga trên đồi xong rồi tán nhau` },
        {
            start: 103,
            end: 107,
            text: `Soi tướng phu thê mình có trán cao cùng quả môi dày tình cảm để cho chúng nó chạm nhau, eh`,
        },
        { start: 107, end: 109, text: `Because now you are my bae` },
        { start: 109, end: 111, text: `'Cause you're now my bae` },
        { start: 111, end: 113, text: `'Cause you're now my bae` },
        { start: 113, end: 114, text: `'Cause you're now my babe` },
        { start: 114, end: 116, text: `Because now you are my bae` },
        { start: 116, end: 118, text: `'Cause you're now my babe` },
        { start: 118, end: 120, text: `'Cause it's you, ooh-ooh-ooh` },
        { start: 120, end: 124, text: `Là bởi vì có em, mây thay màu` },
        { start: 124, end: 128, text: `Đẹp tựa bao giấc mơ chôn sâu anh từng giấu` },
        { start: 128, end: 131, text: `Bởi vì là chính em mang u sầu` },
        { start: 131, end: 140, text: `Gửi vào làn gió bay xa để khung trời anh giữ sẽ có thêm màu xanh` },
        { start: 150, end: 154, text: `Có lẽ ngày mai khi đôi mắt đã dần phai phôi` },
        { start: 154, end: 157, text: `Vẫn đưa theo ngàn mây chờ tia nắng phía bờ môi ấy` },
        { start: 157, end: 165, text: `Khẽ nắm bàn tay đang ôm tiếng nói của anh rất lâu, huh-ooh-ooh-oh` },
        { start: 165, end: 168, text: `Thấp thoáng mùi hương vương trên mái tóc của em` },
        { start: 168, end: 172, text: `Đưa giấc mơ đang chìm sâu về bên nắng gió cùng lời ca` },
        { start: 172, end: 177, text: `Giấu tháng ngày bơ vơ trong ánh mắt mà em vẫn đang trao đến anh` },
        { start: 177, end: 182, text: `Là bởi vì có em, mây thay màu (có em)` },
        { start: 182, end: 185, text: `Đẹp tựa bao giấc mơ chôn sâu anh từng giấu (từng giấu, từng giấu)` },
        { start: 185, end: 189, text: `Bởi vì là chính em mang u sầu (chính em, chính em)` },
        { start: 189, end: 193, text: `Gửi vào làn gió bay xa để khung trời anh giữ sẽ có thêm màu xanh` },
        { start: 193, end: 195, text: `Because now you're now my bae` },
        { start: 195, end: 197, text: `'Cause you're now my bae` },
        { start: 197, end: 199, text: `'Cause you're now my bae` },
        { start: 199, end: 200, text: `'Cause you're now my babe` },
        { start: 200, end: 202, text: `Because now you're now my bae` },
        { start: 202, end: 204, text: `'Cause you're now my babe` },
        { start: 204, end: 206, text: `('Cause it's you) 'Cause you're now my bae (yeah, yeah)` },
        { start: 206, end: 214, text: `'Cause you're now my babe, eh, yeah-yeah` },
    ],
    'tiny-love': [
        { start: 21, end: 25, text: `Làm lại từ những thứ đơn giản nhất chuyện trò như lúc mới yêu` },
        { start: 25, end: 30, text: `Tình mình như thứ nước hoa phảng phất nồng nàn như bát bún riêu` },
        { start: 30, end: 35, text: `Này người yêu dấu nếu trong một chốc buồn sầu đeo bám chúng ta` },
        { start: 35, end: 41, text: `Thì đừng vội trách cớ sao tàn khốc vì niềm đau ấy sẽ qua` },
        { start: 41, end: 46, text: `Sẽ qua thôi những u buồn thế gian` },
        { start: 46, end: 50, text: `Tình yêu sẽ cháy nhưng không tro tàn` },
        { start: 50, end: 54, text: `You're my ti ti tiny love` },
        { start: 54, end: 59, text: `Baby you're my ti ti tiny love` },
        { start: 59, end: 64, text: `You're my ti ti tiny love` },
        { start: 64, end: 72, text: `Baby you're my time time timeless love` },
        { start: 88, end: 92, text: `Một chiều ta đứng kế bên nhìn ngắm cuộc đời như những bức tranh` },
        { start: 92, end: 98, text: `Dạo từng khu phố lúc xưa chìm đắm mà giờ sao thấy mới toanh` },
        { start: 98, end: 102, text: `Đồng hồ nhanh quá mới đây mà hết đời người như những giấc mơ` },
        { start: 102, end: 108, text: `Làm gì cho đáng để sau này vết lời mình như những ý thơ` },
        { start: 108, end: 113, text: `Ý thơ trong những đau buồn thế gian` },
        { start: 113, end: 117, text: `Tình yêu sẽ cháy nhưng không tro tàn` },
        { start: 117, end: 121, text: `You're my ti ti tiny love` },
        { start: 121, end: 127, text: `Baby you're my ti ti tiny love` },
        { start: 127, end: 131, text: `You're my ti ti tiny love` },
        { start: 131, end: 136, text: `Baby you're my time time timeless love` },
        { start: 136, end: 141, text: `I wanna love you till the end of time` },
        { start: 141, end: 146, text: `Things gonna change but not my mind` },
        { start: 146, end: 150, text: `I needed love just like I need you` },
        { start: 150, end: 157, text: `I love you my tiny tiny baby blue` },
    ],
    'chuyen-doi-ta': [
        { start: 1, end: 4, text: `Những cơn sóng xô lâu đài vỡ trong bóng đêm` },
        { start: 4, end: 7, text: `Nỗi đau cứ như đang vội ghé thăm trái tim` },
        { start: 7, end: 10, text: `Chiều hoàng hôn kéo theo mây đen về` },
        { start: 10, end: 15, text: `Phủ kín trong tâm tư bóng hình em hoh` },
        { start: 15, end: 18, text: `Ánh trăng dần khuất sau khu rừng` },
        { start: 18, end: 22, text: `Chạy theo sau lưng anh ký ức không thể quên` },
        { start: 22, end: 24, text: `Vì sau cơn mưa đêm qua` },
        { start: 24, end: 28, text: `Không ai nhắc về chuyện đôi ta` },
        { start: 28, end: 32, text: `Em vội vàng khoá con tim em trong một giây` },
        { start: 32, end: 35, text: `Giọt sương nhẹ rớt theo cơn gió thu vội bay` },
        { start: 35, end: 43, text: `Tình yêu chạy đến chân trời xa phút chốc đã khiến em gục ngã oh oh` },
        { start: 43, end: 46, text: `Tựa lưng vào gốc cây chênh vênh em có thấy` },
        { start: 46, end: 50, text: `Mây trời như cũng đã thành đôi (đã thành đôi)` },
        { start: 50, end: 56, text: `Thôi đành cất những ký ức bên nhau xem như quên đi mối tình đầu` },
        { start: 56, end: 58, text: `Uh` },
        { start: 58, end: 61, text: `Những cơn sóng xô lâu đài vỡ trong bóng đêm` },
        { start: 61, end: 65, text: `Nỗi đau cứ như đang vội ghé thăm trái tim` },
        { start: 65, end: 67, text: `Chiều hoàng hôn kéo theo mây đen về` },
        { start: 67, end: 72, text: `Phủ kín trong tâm tư bóng hình em hoh` },
        { start: 72, end: 75, text: `Ánh trăng dần khuất sau khu rừng` },
        { start: 75, end: 79, text: `Chạy theo sau lưng anh ký ức không thể quên` },
        { start: 79, end: 81, text: `Vì sau cơn mưa đêm qua` },
        { start: 81, end: 86, text: `Không ai nhắc về chuyện đôi ta` },
        { start: 86, end: 90, text: `Kết bộ phim em rời đi mang theo chút nắng tàn phai` },
        { start: 90, end: 93, text: `Xoã làn tóc cúi mặt khóc đâu cần thiết biết chuyện mai` },
        { start: 93, end: 98, text: `Đôi mắt đen nhoè dần cánh tay gạt vội nước mắt rơi` },
        { start: 98, end: 100, text: `No no no` },
        { start: 100, end: 104, text: `Soạn vài dòng tin nhắn rồi đốt đi khung hình` },
        { start: 104, end: 108, text: `Dậm vào màu son mới em cất bước đi` },
        { start: 108, end: 113, text: `Giữa phố đông người nhưng nỗi cô đơn vẫn cuộn chặt vào em` },
        { start: 113, end: 115, text: `Nana` },
        { start: 115, end: 119, text: `Những cơn sóng xô` },
        { start: 119, end: 122, text: `Vỡ trong bóng đêm` },
        { start: 122, end: 124, text: `Hoàng hôn kéo theo mây đen về` },
        { start: 124, end: 130, text: `Phủ kín trong tâm tư bóng hình em` },
        { start: 130, end: 132, text: `Ánh trăng dần khuất sau khu rừng` },
        { start: 132, end: 136, text: `Chạy theo sau lưng anh ký ức không thể quên` },
        { start: 136, end: 138, text: `Vì sau cơn mưa đêm qua` },
        { start: 138, end: 144, text: `Không ai nhắc về chuyện đôi ta` },
        { start: 144, end: 147, text: `Những cơn sóng xô lâu đài vỡ trong bóng đêm` },
        { start: 147, end: 151, text: `Nỗi đau cứ như đang vội ghé thăm trái tim` },
        { start: 151, end: 153, text: `Chiều hoàng hôn kéo theo mây đen về` },
        { start: 153, end: 159, text: `Phủ kín trong tâm tư bóng hình em hoh` },
        { start: 159, end: 161, text: `Ánh trăng dần khuất sau khu rừng` },
        { start: 161, end: 165, text: `Chạy theo sau lưng anh ký ức không thể quên` },
        { start: 165, end: 167, text: `Vì sau cơn mưa đêm qua` },
        { start: 167, end: 175, text: `Không ai nhắc về chuyện đôi ta (chuyện đôi ta chuyện đôi ta huh)` },
    ],
    'chiec-hop': [
        { start: 17, end: 25, text: `Ta đi ngang bao phút vui buồn cùng nhau` },
        { start: 25, end: 31, text: `Sau chia tay có lẽ em không còn giận` },
        { start: 31, end: 33, text: `Đột nhiên em nghĩ` },
        { start: 33, end: 35, text: `Mình làm gì khi` },
        { start: 35, end: 41, text: `Ở trong tim ai cũng có một chiếc hộp` },
        { start: 41, end: 47, text: `Lưu bao nhiêu kí ức về nhau khi yêu` },
        { start: 47, end: 55, text: `Nếu như cho anh chọn thì anh có cất chiếc hôn đầu tiên?` },
        { start: 55, end: 61, text: `Nếu như cho anh chọn thì anh có cất chiếc ôm mùa đông?` },
        { start: 61, end: 65, text: `Chờ anh qua bao tối đường rất xa` },
        { start: 65, end: 71, text: `Chỉ để mong có mỗi mấy phút ôm` },
        { start: 71, end: 79, text: `Nếu như cho em chọn thì em xin cất những điều đẹp nhất` },
        { start: 97, end: 105, text: `Ta yêu nhau rồi cứ thế xa rời nhau` },
        { start: 105, end: 111, text: `Hôm chia tay anh tiễn em về một đoạn` },
        { start: 111, end: 115, text: `Giờ đây em nghĩ rằng ta đã đúng` },
        { start: 115, end: 121, text: `Dù cho khi đó thấy xót xa vô cùng` },
        { start: 121, end: 127, text: `Em luôn mong anh cũng cảm nhận như em` },
        { start: 127, end: 135, text: `Nếu như cho anh chọn thì anh có cất ánh chiều hoàng hôn` },
        { start: 135, end: 137, text: `Dát lên nơi ta thường ngồi lâu` },
        { start: 137, end: 141, text: `Tay nắm khó mà chặt hơn` },
        { start: 141, end: 145, text: `Ngồi bên nhau yên ắng chỉ chúng ta` },
        { start: 145, end: 151, text: `Vì ta đâu quen hứa thứ quá xa` },
        { start: 151, end: 159, text: `Nếu như cho em chọn thì em xin cất những điều đẹp nhất` },
        { start: 159, end: 170, text: `Nếu như cho anh chọn liệu anh có cất những điều đẹp nhất?` },
    ],
    'da-lo-yeu-em-nhieu': [
        { start: 3, end: 9, text: `Đã lỡ yêu lỡ yêu yêu` },
        { start: 9, end: 15, text: `Đã lỡ yêu lỡ yêu yêu` },
        { start: 15, end: 21, text: `Đã lỡ yêu lỡ yêu yêu` },
        { start: 21, end: 23, text: `Đã lỡ yêu lỡ yêu` },
        { start: 23, end: 25, text: `Can you feel me` },
        { start: 25, end: 29, text: `Đã lỡ yêu em nhiều rồi thì anh chỉ biết ngắm mưa` },
        { start: 29, end: 33, text: `Nhìn qua hàng cây được bao nhiêu hạt mưa` },
        { start: 33, end: 37, text: `Là trong anh được bấy nhiêu nỗi nhớ em` },
        { start: 37, end: 41, text: `Đã lỡ yêu em nhiều rồi thì anh chỉ biết đếm sao` },
        { start: 41, end: 45, text: `Nhìn lên trời cao được bao nhiêu vì sao` },
        { start: 45, end: 48, text: `Là trong lòng anh còn bấy nhiêu những nỗi lo` },
        { start: 48, end: 53, text: `Sợ mình đánh mất em khi thu vừa sang lá xanh bỗng úa vàng` },
        { start: 53, end: 60, text: `Khi mưa còn chưa tới em thay người yêu mới oh no no` },
        { start: 60, end: 65, text: `Sợ mình sẽ khiến em yêu phai nhạt hơn giữa mênh mông bộn bề` },
        { start: 65, end: 68, text: `Em ơi chờ anh với (chờ anh với)` },
        { start: 68, end: 71, text: `Chỉ biết nói cho em nghe vậy thôi` },
        { start: 71, end: 77, text: `Vì đã lỡ yêu em rồi chẳng dám hứa xa xôi` },
        { start: 77, end: 81, text: `Cứ nhắm mắt em lại và feel my love` },
        { start: 81, end: 86, text: `Dù nắng mưa bao mùa thì tình anh vẫn luôn đây mà` },
        { start: 86, end: 89, text: `Chẳng phải kiếm đâu xa` },
        { start: 89, end: 93, text: `Vẫn giữ đó bầu trời của riêng chúng ta` },
        { start: 93, end: 97, text: `Để gió mang đi về một nơi không người` },
        { start: 97, end: 101, text: `Đã lỡ yêu em nhiều rồi thì anh chỉ biết thế thôi (thế thôi)` },
        { start: 101, end: 105, text: `Dù mai về sau mình không bên cạnh nhau` },
        { start: 105, end: 109, text: `Dù tim mình đau khi biết em đã lỡ yêu người` },
        { start: 109, end: 113, text: `Đã lỡ yêu em nhiều rồi thì anh sẽ bất chấp luôn (bất chấp luôn)` },
        { start: 113, end: 116, text: `Dù mưa dù giông dù sông sâu biển xa (biển xa)` },
        { start: 116, end: 119, text: `Dù nắng cháy anh cũng không hề lo` },
        { start: 119, end: 125, text: `Chỉ sợ mình đánh mất em khi thu vừa sang lá xanh bỗng úa vàng (oh oh)` },
        { start: 125, end: 132, text: `Khi mưa còn chưa tới em thay người yêu mới oh no` },
        { start: 132, end: 138, text: `Sợ mình sẽ khiến em yêu phai nhạt hơn giữa mênh mông bộn bề` },
        { start: 138, end: 140, text: `Em ơi chờ anh với (chờ anh với)` },
        { start: 140, end: 143, text: `Chỉ biết nói cho em nghe vậy thôi (chỉ biết nói)` },
        { start: 143, end: 149, text: `Vì đã lỡ yêu em rồi chẳng dám hứa xa xôi` },
        { start: 149, end: 153, text: `Cứ nhắm mắt em lại và feel my love` },
        { start: 153, end: 158, text: `Dù nắng mưa bao mùa thì tình anh vẫn luôn đây mà` },
        { start: 158, end: 161, text: `Chẳng phải kiếm đâu xa` },
        { start: 161, end: 165, text: `Vẫn giữ đó bầu trời của riêng chúng ta` },
        { start: 165, end: 168, text: `Để gió mang đi về một nơi không người` },
        { start: 168, end: 171, text: `Đã lỡ yêu nah nah nah (đã lỡ yêu)` },
        { start: 171, end: 174, text: `Oh oh lỡ yêu nah nah nah (lỡ yêu)` },
        { start: 174, end: 177, text: `I love you so (bae I love you so)` },
        { start: 177, end: 180, text: `Mình phải bước chậm lại vì ngày mai rất dài` },
        { start: 180, end: 183, text: `Đã lỡ yêu nah nah nah (đã lỡ yêu)` },
        { start: 183, end: 186, text: `Oh oh lỡ yêu nah nah nah (lỡ yêu)` },
        { start: 186, end: 189, text: `I love you so (bae I love you so)` },
        { start: 189, end: 192, text: `Mình phải bước chậm lại chậm lại` },
        { start: 192, end: 195, text: `Vì biết đâu sớm mai thức dậy` },
        { start: 195, end: 198, text: `Em không còn đây ôm anh nhẹ hôn anh` },
        { start: 198, end: 201, text: `Để tình ta cứ trôi lững lờ` },
        { start: 201, end: 204, text: `Chờ giông và bão cuốn đi bất ngờ` },
        { start: 204, end: 207, text: `Giờ lỡ đâu giấc mơ không thành` },
        { start: 207, end: 210, text: `Em không còn kề vai anh tình mong manh` },
        { start: 210, end: 215, text: `Một người đứng cứ trông với chờ người kia thì ôm giấc mơ` },
        {
            start: 215,
            end: 221,
            text: `Vì đã lỡ yêu em rồi chẳng dám hứa xa xôi (chẳng dám hứa thêm gì nữa no no no no no)`,
        },
        { start: 221, end: 225, text: `Cứ nhắm mắt em lạc vào feel my love (can you feel my love love bae)` },
        { start: 225, end: 230, text: `Dù cho bao mùa anh vẫn đây mà (thì tình anh vẫn luôn đây mà)` },
        { start: 230, end: 233, text: `Chẳng phải kiếm đâu xa` },
        {
            start: 233,
            end: 237,
            text: `Vẫn giữ đó bầu trời của riêng chúng ta (I love you so much I love you so much love you so much)`,
        },
        { start: 237, end: 240, text: `Để gió mang đi về một nơi không người (I love you so much)` },
        { start: 240, end: 242, text: `Đã lỡ yêu` },
        { start: 242, end: 254, text: `Vì một người lỡ yêu (lỡ yêu)` },
    ],
    'nem-cau-yeu-vao-trong-khong-trung': [
        { start: 16, end: 20, text: `Ϲó những ký ức không thể quên` },
        { start: 20, end: 23, text: `Là thấp thoáng những xuуến xao đầu tiên` },
        { start: 23, end: 26, text: `Mỗi chiều tiếng ve` },
        { start: 26, end: 32, text: `Tôi vờ như hư xe, chờ em` },
        { start: 32, end: 36, text: `Hoàng hôn buông vệt dài nơi cuối đường` },
        { start: 36, end: 39, text: `Hắt sáng bóng dáng tôi thầm thương` },
        { start: 39, end: 42, text: `Em là lý do` },
        { start: 42, end: 47, text: `Tôi biết vấn vương trong đời` },
        { start: 47, end: 57, text: `Dù em đâu haу biết tới` },
        { start: 57, end: 61, text: `Và tôi sẽ ném câu уêu em` },
        { start: 61, end: 64, text: `Vào trong không trung` },
        { start: 64, end: 67, text: `Ϲhờ cho gió cuốn đi xa` },
        { start: 67, end: 69, text: `Lặng уên nhớ thương một người` },
        { start: 69, end: 72, text: `Dẫu nhiều lạc lõng` },
        { start: 72, end: 75, text: `Ѕao vẫn hoài ngóng trông` },
        { start: 75, end: 79, text: `Giữ cho riêng mình phút giâу уên bình` },
        { start: 79, end: 81, text: `Bước bên cạnh nhau` },
        { start: 81, end: 83, text: `Ϲhờ ngàу em cất lời` },
        { start: 83, end: 86, text: `Rằng sẽ không xa rời` },
        { start: 86, end: 94, text: `Dù cho уêu em đơn phương mà thôi` },
        { start: 105, end: 109, text: `Bối rối lúc vẫу taу là tôi` },
        { start: 109, end: 112, text: `Vui khi đi bên em là tôi` },
        { start: 112, end: 117, text: `Rung động mỗi khi hoa rớt trên vai` },
        { start: 117, end: 120, text: `Em khẽ cười` },
        { start: 120, end: 122, text: `Ɲgập tràn trong tôi` },
        { start: 122, end: 126, text: `Một tình уêu chưa nói` },
        { start: 126, end: 129, text: `Và tôi sẽ ném câu уêu em` },
        { start: 129, end: 131, text: `Vào trong không trung` },
        { start: 131, end: 134, text: `Ϲhờ cho gió cuốn đi xa` },
        { start: 134, end: 136, text: `Lặng уên nhớ thương một người` },
        { start: 136, end: 139, text: `Dẫu nhiều lạc lõng` },
        { start: 139, end: 142, text: `Ѕao vẫn hoài ngóng trông` },
        { start: 142, end: 146, text: `Giữ cho riêng mình phút giâу уên bình` },
        { start: 146, end: 148, text: `Bước bên cạnh nhau` },
        { start: 148, end: 150, text: `Ϲhờ ngàу em cất lời` },
        { start: 150, end: 153, text: `Rằng sẽ không xa rời` },
        { start: 153, end: 159, text: `Dẫu cho tôi уêu em đơn phương` },
        { start: 159, end: 163, text: `Làm sao giúp tôi dừng lại thời gian trôi` },
        { start: 163, end: 167, text: `Để mãi đứng bên em không rời` },
        { start: 167, end: 169, text: `Ѕợ mai cuộc sống kia rối bời` },
        { start: 169, end: 179, text: `Em ở bên một người không phải tôi` },
        { start: 179, end: 183, text: `Và tôi sẽ ném câu уêu em` },
        { start: 183, end: 189, text: `Vào trong không trung` },
        { start: 189, end: 191, text: `Lặng уên nhớ thương một người` },
        { start: 191, end: 194, text: `Dẫu nhiều lạc lõng` },
        { start: 194, end: 197, text: `Ѕao tôi vẫn mãi luôn trông mong` },
        { start: 197, end: 201, text: `Giữ cho riêng mình phút giâу уên bình` },
        { start: 201, end: 203, text: `Bước bên cạnh nhau` },
        { start: 203, end: 205, text: `Ϲhờ ngàу em cất lời` },
        { start: 205, end: 208, text: `Rằng sẽ không xa rời` },
        { start: 208, end: 222, text: `Dẫu cho tôi уêu em đơn phương mà thôi` },
    ],
    'cau-tra-loi': [
        { start: 5, end: 8, text: `Anh đâu cần tôi,` },
        { start: 8, end: 11, text: `Đâu cần ai, ai cần tôi?` },
        { start: 11, end: 13, text: `Tôi cần ai?` },
        { start: 13, end: 18, text: `Tôi là ai, trong anh?` },
        { start: 18, end: 24, text: `Anh đang mải miết, đi tìm kiếm những phù du.` },
        { start: 24, end: 31, text: `Tôi chẳng biết phải làm sao để làm anh vui?` },
        { start: 31, end: 44, text: `Là vì khi màn đêm buông xuống lòng mình, vẫn những câu hỏi cũ "mình là ai?"` },
        { start: 44, end: 51, text: `Góc phố chiều đón đưa giờ biết ai trong vòng tay ai,` },
        { start: 51, end: 58, text: `Dắt nhau đi qua ngày mai.` },
        { start: 58, end: 64, text: `Phút yếu lòng hỏi anh rằng "anh yêu mình em không?"` },
        { start: 64, end: 71, text: `Khoé mắt anh buông câu trả lời.` },
        { start: 71, end: 77, text: `Anh trong lòng tôi đang cần ai, đâu cần tôi.` },
        { start: 77, end: 79, text: `Tôi cần ai?` },
        { start: 79, end: 84, text: `Tôi cần xa.. nơi đây.` },
        { start: 84, end: 90, text: `Anh đang mải miết đi tìm kiếm những phù du.` },
        { start: 90, end: 97, text: `Tôi chẳng biết phải làm sao để làm anh vui?` },
        { start: 97, end: 110, text: `Là vì khi màn đêm buông xuống lòng mình,vẫn những câu hỏi cũ :"mình là ai?"` },
        { start: 110, end: 117, text: `Góc phố chiều đón đưa giờ biết ai trong vòng tay ai` },
        { start: 117, end: 123, text: `Dắt nhau đi qua ngày mai` },
        { start: 123, end: 130, text: `Phút yếu lòng hỏi anh rằng "anh yêu mình em không ?"` },
        { start: 130, end: 141, text: `Khoé mắt anh buông câu trả lời.` },
        { start: 141, end: 146, text: `Anh trong lòng tôi đang cần ai..` },
        { start: 146, end: 148, text: `Đâu cần tôi.` },
        { start: 148, end: 150, text: `Tôi cần ai?` },
        { start: 150, end: 160, text: `Tôi cần xa.. nơi đây.` },
    ],
    'em-thich': [
        { start: 21, end: 23, text: `Và nếu em thấy cô đơn cô đơn` },
        { start: 23, end: 27, text: `Anh sẽ luôn ở đây vì` },
        { start: 27, end: 32, text: `Anh chẳng muốn công chúa của anh ướt mi` },
        { start: 32, end: 33, text: `Lại đây để anh ôm` },
        { start: 33, end: 38, text: `Anh ôm em thật lâu nà` },
        { start: 38, end: 39, text: `Anh sẽ trao hết yêu thương` },
        { start: 39, end: 43, text: `Để em quên mau` },
        { start: 43, end: 46, text: `Hai giờ đêm anh vẫn còn nhớ` },
        { start: 46, end: 48, text: `Những lúc ta trao nhau ngọt ngào` },
        { start: 48, end: 51, text: `Phải làm sao để giữ trái tim` },
        { start: 51, end: 54, text: `Luôn đong đầy mà không nhạt phai` },
        { start: 54, end: 56, text: `Cho lòng anh mơ màng` },
        { start: 56, end: 57, text: `Rồi rơi xuống đây` },
        { start: 57, end: 59, text: `Làm con tim anh đắm say` },
        { start: 59, end: 61, text: `Chỉ muốn nắm tay người` },
        { start: 61, end: 65, text: `Và đi hết cuộc đời này` },
        { start: 65, end: 67, text: `Và nếu em thấy cô đơn cô đơn` },
        { start: 67, end: 70, text: `Anh sẽ luôn ở đây vì` },
        { start: 70, end: 76, text: `Anh chẳng muốn công chúa của anh ướt mi` },
        { start: 76, end: 77, text: `Lại đây để anh ôm` },
        { start: 77, end: 81, text: `Anh ôm em thật lâu nà` },
        { start: 81, end: 83, text: `Anh sẽ trao hết yêu thương` },
        { start: 83, end: 87, text: `Để em quên mau` },
        { start: 87, end: 88, text: `Em thích đi dạo phố` },
        { start: 88, end: 89, text: `Trên tay cầm phô mai que` },
        { start: 89, end: 91, text: `Rồi mở bài nhạc của anh` },
        { start: 91, end: 92, text: `Bật max âm lượng kề vô tai nghe` },
        { start: 92, end: 93, text: `Em thích ăn cá viên chiên` },
        { start: 93, end: 95, text: `Em thích hồng trà sữa` },
        { start: 95, end: 96, text: `Em nói em mong sau này` },
        { start: 96, end: 97, text: `Có một người chồng là Lửa` },
        { start: 97, end: 99, text: `Em thích anh sờ đầu em` },
        { start: 99, end: 100, text: `Cảm giác cute khó nói` },
        { start: 100, end: 101, text: `Anh hỏi em thương anh không` },
        { start: 101, end: 103, text: `Lúc đó làm em khó chối` },
        { start: 103, end: 104, text: `Em thích được anh vếu má` },
        { start: 104, end: 106, text: `Rồi đặt nhẹ bờ môi lên` },
        { start: 106, end: 107, text: `Em cũng làm ngược lại` },
        { start: 107, end: 108, text: `Để cho cân đều đôi bên` },
        { start: 108, end: 110, text: `Em thích màu xanh màu đỏ` },
        { start: 110, end: 111, text: `Không thích màu hồng cánh sen` },
        { start: 111, end: 113, text: `Em nói là em có phép thuật Winx` },
        { start: 113, end: 114, text: `Thì anh đừng hòng đánh em` },
        { start: 114, end: 115, text: `Em thích tình yêu đơn giản` },
        { start: 115, end: 116, text: `Không thích nhiều điều phức tạp` },
        { start: 116, end: 118, text: `Em nói anh chính là nơi vững chắc` },
        { start: 118, end: 119, text: `Cho em thật nhiều sức đạp` },
        { start: 119, end: 121, text: `Em thích xuống bếp nấu ăn` },
        { start: 121, end: 122, text: `Dở ẹc mà không dám nói` },
        { start: 122, end: 123, text: `Con cá đen thui thùi lùi` },
        { start: 123, end: 125, text: `Ẩn mình ở trong đám khói` },
        { start: 125, end: 126, text: `Em thích ra biển cùng anh` },
        { start: 126, end: 127, text: `Không thích làm kẻ sea tình` },
        { start: 127, end: 129, text: `Nếu mà hiểu được tính tình của em` },
        { start: 129, end: 130, text: `Kể ra cũng cả quy trình` },
        { start: 130, end: 132, text: `Và nếu em thấy cô đơn cô đơn` },
        { start: 132, end: 136, text: `Anh sẽ luôn ở đây vì` },
        { start: 136, end: 141, text: `Anh chẳng muốn công chúa của anh ướt mi` },
        { start: 141, end: 143, text: `Lại đây để anh ôm` },
        { start: 143, end: 147, text: `Anh ôm em thật lâu nà` },
        { start: 147, end: 148, text: `Anh sẽ trao hết yêu thương` },
        { start: 148, end: 152, text: `Để em quên mau` },
        { start: 152, end: 158, text: `Và nếu em thấy cô đơn cô đơn` },
        { start: 158, end: 163, text: `Anh chẳng muốn công chúa của anh ướt mi` },
        { start: 163, end: 169, text: `Lại đây để anh ôm anh ôm` },
        { start: 169, end: 170, text: `Anh sẽ trao hết yêu thương` },
        { start: 170, end: 175, text: `Để em quên mau` },
    ],
    'tu-choi-nhe-nhang-thoi': [
        { start: 12, end: 14, text: `Tình cảm này khó nói` },
        { start: 14, end: 17, text: `Nếu thật sự chẳng thể giấu nữa` },
        { start: 17, end: 21, text: `Thôi đừng lo em hứa` },
        { start: 21, end: 24, text: `Rằng sẽ từ chối anh nhẹ nhàng` },
        { start: 24, end: 26, text: `Tình cảm này khó nói` },
        { start: 26, end: 29, text: `Nếu thật sự chẳng thể né tránh` },
        { start: 29, end: 32, text: `Nói thật nhanh đi anh` },
        { start: 32, end: 36, text: `Để em từ chối anh nhẹ nhàng thôi` },
        { start: 36, end: 38, text: `Ta thường mơ về một thoáng chốc được bên nàng` },
        { start: 38, end: 41, text: `Tâm hồn say lạc giữa thành phố một đêm vàng` },
        { start: 41, end: 44, text: `Dưới ánh đèn đường hiu hắt, tương tư văng vẳng không im` },
        { start: 44, end: 47, text: `Nàng chỉ gửi một ánh mắt, ta đã trao cả con tim` },
        { start: 47, end: 49, text: `Giữa biển người nhưng anh chỉ có em trong mắt` },
        { start: 49, end: 52, text: `Giữa một rừng thanh âm chỉ nghe thấy tiếng em trong vắt` },
        { start: 52, end: 55, text: `Đêm xuống, tâm tư anh là nhà giam` },
        { start: 55, end: 57, text: `Với nỗi nhớ về em là song sắt` },
        { start: 57, end: 60, text: `Nhưng tình cảm đâu phải nhành cây, nên nó đâu có dễ?` },
        { start: 60, end: 63, text: `Ta như vai áo em buông, bởi vì ta quá trễ` },
        { start: 63, end: 66, text: `Giờ đến và cướp em đi, là điều ta không được làm` },
        { start: 66, end: 69, text: `Vì sợi tơ hồng đang buộc ta, nó lại không buộc nàng` },
        { start: 69, end: 72, text: `Nên nếu em không thể đưa ra lựa chọn` },
        { start: 72, end: 75, text: `Thì xin em hãy sớm đẩy anh đi xa` },
        { start: 75, end: 78, text: `Nếu bờ môi ấy không thể cho anh vị ngọt` },
        { start: 78, end: 82, text: `Thì em hãy để nó buông cho anh lời vị tha` },
        { start: 82, end: 88, text: `Ở bên anh em thấy trái tim thổn thức cứ không thể dứt, babe` },
        { start: 88, end: 91, text: `Nhưng ta không nên xem chương tiếp theo` },
        { start: 91, end: 94, text: `Vì chuyện tình này có kết cục buồn` },
        { start: 94, end: 99, text: `Mà em không mong muốn thấy anh buồn bã thế đâu dừng bước đi anh` },
        { start: 99, end: 102, text: `Đôi khi em bâng khuâng khi nghĩ rằng` },
        { start: 102, end: 110, text: `Sự thật là mình không thể bên nhau` },
        { start: 116, end: 118, text: `Anh vẫn cần em nhiều lắm` },
        { start: 118, end: 121, text: `Như một rừng cây ở giữa trời đông đang cần một chiều nắng` },
        { start: 121, end: 124, text: `Nàng lạnh lùng như tảng băng trôi, khi ở xa mà ta nhìn ngắm` },
        { start: 124, end: 127, text: `Anh đâu phải Titanic sao cứ gặp em là anh chìm đắm?` },
        { start: 127, end: 130, text: `Ta đã cố tìm cách khác nhưng nó không nằm trong sách vở` },
        { start: 130, end: 133, text: `Cách duy nhất mà ta có dường như chỉ là cách trở` },
        { start: 133, end: 136, text: `Em như là một cơn nghiện vẫn dày vò anh nhiều quá` },
        { start: 136, end: 138, text: `Nàng đã cho ta có cửa nhưng sao lại tiếc cái chìa khóa?` },
        { start: 138, end: 141, text: `Vì thương nàng nên giấc không yên, ta vẫn chẳng thể nào ngủ` },
        { start: 141, end: 144, text: `Lí trí là đứa nhân viên vì nó thật khó để làm chủ` },
        { start: 144, end: 147, text: `Đếm từng ngày xa lòng ta nặng nề như đá đổ` },
        { start: 147, end: 150, text: `Anh mang tình cảm lớn người ta bảo là quá khổ` },
        { start: 150, end: 153, text: `Không có nơi nào có thể là vườn địa đàng` },
        { start: 153, end: 156, text: `Nếu như nơi đó em không thể ở gần anh` },
        { start: 156, end: 159, text: `Anh chẳng muốn nghe một lời từ chối nhẹ nhàng` },
        { start: 159, end: 162, text: `Hãy cho hi vọng của anh một cái chết thật nhanh` },
        { start: 162, end: 171, text: `Người có thể hờn trách em khi mà em luôn thức đêm bỏ mặc anh trong giấc mơ` },
        { start: 171, end: 174, text: `Ngày hay đêm vẫn mơ` },
        { start: 174, end: 182, text: `Hoặc có thể quên lãng em khi mà em không dắt tay anh vào trong nơi trái tim` },
        { start: 182, end: 188, text: `Bỏ mặc anh đứng im` },
        { start: 188, end: 191, text: `Tình cảm này khó nói` },
        { start: 191, end: 194, text: `Em nhìn anh mà lòng bối rối` },
        { start: 194, end: 197, text: `Muộn màng rôi anh ơi` },
        { start: 197, end: 200, text: `Bởi vì người đến sau mất rồi` },
        { start: 200, end: 202, text: `Vào một ngày nắng tắt` },
        { start: 202, end: 205, text: `Lỡ nhận trao nhầm một ánh mắt` },
        { start: 205, end: 209, text: `Cô là người đáng trách` },
        { start: 209, end: 219, text: `Kẻ tình si đáng quên lại là anh` },
    ],
    'van-nho': [
        { start: 25, end: 29, text: `Trời chiều vàng úa, ngồi buồn nhìn từng đợt sóng` },
        { start: 29, end: 35, text: `Hải âu vỗ cánh gọi` },
        { start: 35, end: 39, text: `Người về xa xăm, cuộc tình xanh xao` },
        { start: 39, end: 45, text: `Bờ mi xót xa` },
        { start: 45, end: 49, text: `Rồi từng ngày qua, từng giọt sầu là lời ca` },
        { start: 49, end: 55, text: `Mà anh đã hát cho em` },
        { start: 55, end: 58, text: `Những tiếc nuối chơi vơi tràn ngập hồn` },
        { start: 58, end: 65, text: `Những ước muốn tin yêu theo mây vội bay` },
        { start: 65, end: 70, text: `Có những lúc anh mơ được gặp lại em lúc ban đầu` },
        { start: 70, end: 75, text: `Có những lúc mình chợt nghe tình như giấc mơ qua` },
        { start: 75, end: 80, text: `Nếu đã lỡ phôi phai ngàn đời em không quay về đây` },
        { start: 80, end: 88, text: `Vẫn nhớ mãi một hình bóng xa vời` },
        { start: 106, end: 110, text: `Trời chiều vàng úa, ngồi buồn nhìn từng đợt sóng` },
        { start: 110, end: 116, text: `Hải âu vỗ cánh gọi (hải âu vỗ cánh gọi)` },
        { start: 116, end: 120, text: `Người về xa xăm, cuộc tình xanh xao` },
        { start: 120, end: 126, text: `Bờ mi xót xa` },
        { start: 126, end: 130, text: `Rồi từng ngày qua, từng giọt sầu là lời ca` },
        { start: 130, end: 136, text: `Mà anh đã hát cho em` },
        { start: 136, end: 139, text: `Những tiếc nuối chơi vơi tràn ngập hồn` },
        { start: 139, end: 146, text: `Những ước muốn tin yêu theo mây vội bay` },
        { start: 146, end: 151, text: `Có những lúc anh mơ được gặp lại em lúc ban đầu` },
        { start: 151, end: 156, text: `Có những lúc mình chợt nghe tình như giấc mơ qua` },
        { start: 156, end: 161, text: `Nếu đã lỡ phôi phai ngàn đời em không quay về đây` },
        { start: 161, end: 166, text: `Vẫn nhớ mãi một hình bóng xa vời` },
        { start: 166, end: 171, text: `Có những lúc anh mơ được gặp lại em lúc ban đầu` },
        { start: 171, end: 176, text: `Có những lúc mình chợt nghe tình như giấc mơ qua` },
        { start: 176, end: 181, text: `Nếu đã lỡ phôi phai ngàn đời em không quay về đây` },
        { start: 181, end: 190, text: `Vẫn nhớ mãi một hình bóng xa vời` },
    ],
    'nam-ngu-em-ru': [
        { start: 18, end: 23, text: `Đừng che giấu em nhé nếu anh đang buồn` },
        { start: 23, end: 27, text: `Người an vui thường chẳng thức đêm thức hôm` },
        { start: 27, end: 37, text: `Mệt chuyện công việc anh muốn kể thì anh cứ kể em nghe` },
        { start: 37, end: 42, text: `Đừng chỉ biết cố gắng mãi trong im lặng` },
        { start: 42, end: 46, text: `Vài hôm anh mệt quá ốm đi em chăm` },
        { start: 46, end: 56, text: `Một khi trong đời anh thấy đủ thì ta thấy đủ thôi anh` },
        { start: 56, end: 60, text: `Nằm bên cạnh em nhắm mắt lại` },
        { start: 60, end: 65, text: `Đừng thao thức chong chong đêm dài` },
        { start: 65, end: 68, text: `Quên tạm đi trái ngang` },
        { start: 68, end: 70, text: `Quên lòng người dối gian` },
        { start: 70, end: 74, text: `Quên được và mất mát` },
        { start: 74, end: 79, text: `Ngủ đi ngủ ngon nhé anh yêu` },
        { start: 79, end: 84, text: `Thả trôi hết đi biết bao điều` },
        { start: 84, end: 86, text: `Trôi vào trong giấc mơ` },
        { start: 86, end: 89, text: `Mơ mọc đôi cánh bay` },
        { start: 89, end: 97, text: `Ngả lưng trên đám mây` },
        { start: 112, end: 117, text: `Đừng che giấu em nhé nếu anh đang buồn` },
        { start: 117, end: 121, text: `Người an vui thường chẳng thức đêm thức hôm` },
        { start: 121, end: 131, text: `Mệt chuyện công việc anh muốn kể thì anh cứ kể em nghe` },
        { start: 131, end: 136, text: `Đừng chỉ biết cố gắng mãi trong im lặng` },
        { start: 136, end: 140, text: `Vài hôm anh mệt quá ốm đi em chăm` },
        { start: 140, end: 150, text: `Một khi trong đời anh thấy đủ thì ta thấy đủ thôi anh` },
        { start: 150, end: 155, text: `Ở trên này anh thấy những gì` },
        { start: 155, end: 159, text: `Đừng chỉ nói xung quanh mây bay` },
        { start: 159, end: 162, text: `Khi mà anh bé thơ` },
        { start: 162, end: 164, text: `Vô tình anh ngước lên` },
        { start: 164, end: 169, text: `Sẽ nhìn ra thứ khác` },
        { start: 169, end: 173, text: `Nhìn ra hình con cá con thuyền` },
        { start: 173, end: 178, text: `Nhìn ra biết bao thứ luyên thuyên` },
        { start: 178, end: 180, text: `Nhưng vì sao lớn hơn` },
        { start: 180, end: 183, text: `Ta tưởng tượng ít hơn` },
        { start: 183, end: 191, text: `Và lại vui ít hơn` },
        { start: 225, end: 230, text: `Đừng chỉ biết cố gắng mãi trong im lặng` },
        { start: 230, end: 235, text: `Vài hôm anh mệt quá ốm đi em chăm` },
        { start: 235, end: 245, text: `Một khi trong đời anh thấy đủ thì ta thấy đủ thôi anh` },
    ],
    'hong-kong': [
        { start: 19, end: 24, text: `Và giờ anh biết chuyện tình mình chẳng còn gì` },
        { start: 24, end: 28, text: `Khi nắng xuân sang lời mật ngọt còn thầm thì` },
        { start: 28, end: 34, text: `Em bước sang ngang đợi chờ một điều diệu kì` },
        { start: 34, end: 38, text: `Như lúc ban đầu` },
        { start: 38, end: 43, text: `Và giờ em khóc thì cũng chẳng để làm gì` },
        { start: 43, end: 48, text: `Đâu phải cho anh chuyện tình mình mà là vì` },
        { start: 48, end: 53, text: `Em đã trao ai dòng lệ tràn đầy cầu kì` },
        { start: 53, end: 59, text: `Những năm tháng phai nhòa` },
        { start: 59, end: 63, text: `Nếu` },
        { start: 63, end: 67, text: `Trái tim mình nói không nên lời` },
        { start: 67, end: 73, text: `Đắng cay từng tiếng yêu xa vời` },
        { start: 73, end: 75, text: `Thế là` },
        { start: 75, end: 77, text: `Như thế là` },
        { start: 77, end: 82, text: `Và hôm nay em đến` },
        { start: 82, end: 87, text: `Nhưng nắng đâu còn thiết tha gọi mời` },
        { start: 87, end: 92, text: `Gió âm thầm lướt qua muôn đời` },
        { start: 92, end: 96, text: `Vì ai vì ai (vì ai vì ai)` },
        { start: 96, end: 101, text: `Vì giờ anh biết chuyện tình mình chẳng còn gì` },
        { start: 101, end: 106, text: `Khi nắng xuân sang lời mật ngọt còn thầm thì` },
        { start: 106, end: 111, text: `Em bước sang ngang đợi chờ một điều diệu kỳ` },
        { start: 111, end: 116, text: `Như lúc ban đầu (như lúc ban đầu)` },
        { start: 116, end: 120, text: `Và giờ em khóc thì cũng chẳng để làm gì` },
        { start: 120, end: 125, text: `Đâu phải cho anh chuyện tình mình mà là vì` },
        { start: 125, end: 130, text: `Em đã trao ai dòng lệ tràn đầy cầu kì` },
        { start: 130, end: 137, text: `Những năm tháng phai nhòa (những năm tháng phai nhòa)` },
        { start: 137, end: 140, text: `Nếu` },
        { start: 140, end: 145, text: `Đóa hoa hồng trước kia trở về` },
        { start: 145, end: 150, text: `Nhánh hương tình thoáng trên câu thề` },
        { start: 150, end: 155, text: `Anh ước rằng` },
        { start: 155, end: 159, text: `Rằng một mai anh đến` },
        { start: 159, end: 164, text: `Anh đón em vào sớm mai trong lành` },
        { start: 164, end: 169, text: `Nhưng đó mãi là giấc mơ không thành` },
        { start: 169, end: 177, text: `Vì ai vì ai` },
        { start: 212, end: 217, text: `Và giờ anh biết chuyện tình mình chẳng còn gì` },
        { start: 217, end: 222, text: `Khi nắng xuân sang lời mật ngọt còn thầm thì` },
        { start: 222, end: 227, text: `Em bước sang ngang đợi chờ một điều diệu kỳ` },
        { start: 227, end: 232, text: `Như lúc ban đầu` },
        { start: 232, end: 237, text: `Và giờ em khóc thì cũng chẳng để làm gì` },
        { start: 237, end: 242, text: `Đâu phải cho anh chuyện tình mình mà là vì` },
        { start: 242, end: 246, text: `Em đã trao ai dòng lệ tràn đầy cầu kì` },
        { start: 246, end: 251, text: `Những năm tháng phai nhòa` },
        { start: 251, end: 256, text: `Và giờ anh biết chuyện tình mình chẳng còn gì` },
        { start: 256, end: 261, text: `Khi nắng xuân sang lời mật ngọt còn thầm thì` },
        { start: 261, end: 266, text: `Em bước sang ngang đợi chờ một điều diệu kì` },
        { start: 266, end: 271, text: `Như lúc ban đầu` },
        { start: 271, end: 276, text: `Và giờ em khóc thì cũng chẳng để làm gì` },
        { start: 276, end: 281, text: `Đâu phải cho anh chuyện tình mình mà là vì` },
        { start: 281, end: 286, text: `Nước mắt êm ru dòng lệ tràn đầy cầu kì` },
        { start: 286, end: 290, text: `Vì em vì em` },
    ],
    'pho-cu-con-anh': [
        { start: 22, end: 30, text: `Đêm lạnh lùng đã làm bùng lên cô đơn tột cùng` },
        { start: 30, end: 37, text: `Nụ cười anh chẳng làm sưởi ấm tim em nữa đâu` },
        { start: 37, end: 44, text: `Yêu để rồi bỏ lại từng thói quen đã một thời` },
        { start: 44, end: 51, text: `Xa là thôi chẳng còn được ở bên nhau cả đời` },
        { start: 51, end: 59, text: `Em bỏ lại phía sau tình yêu này` },
        { start: 59, end: 65, text: `Sau hôm nay ta sẽ gọi mình là người yêu cũ` },
        { start: 65, end: 69, text: `Người có còn đi qua từng góc phố?` },
        { start: 69, end: 73, text: `Người có còn yêu bao phút giây hẹn hò?` },
        { start: 73, end: 76, text: `Còn sợ mỗi tối khi đông gió về?` },
        { start: 76, end: 80, text: `Chờ em, em tới ôm anh thật lâu` },
        { start: 80, end: 84, text: `Từng phút từng giây yêu thương lìa xa` },
        { start: 84, end: 88, text: `Giọt nước mắt anh sao đớn đau lòng quá` },
        { start: 88, end: 91, text: `Tạm biệt hạnh phúc trao nhau hồi nào` },
        { start: 91, end: 97, text: `Tạm biệt chàng trai em đã từng yêu` },
        { start: 97, end: 105, text: `Em đã từng rất yêu` },
        { start: 116, end: 118, text: `Em ngủ chưa hay là còn đang thức?` },
        { start: 118, end: 119, text: `Cà phê cũng đã vơi nửa ly` },
        { start: 119, end: 121, text: `Đừng làm máy anh ngày đêm phải chầu trực` },
        { start: 121, end: 123, text: `Còn giận dỗi thì không mau mà sửa đi` },
        { start: 123, end: 125, text: `Em nói ngày bên anh là trăng mật` },
        { start: 125, end: 127, text: `Ông trời chứng giám tơ hồng sẽ không phai` },
        { start: 127, end: 128, text: `Có nỗi lòng nhiều hai ta sẽ chẳng cất` },
        { start: 128, end: 130, text: `Vẫn sẽ chung lối dù hạ ngắn hay đông dài` },
        { start: 130, end: 132, text: `Máy hết tiền tổng đài báo anh trước` },
        { start: 132, end: 134, text: `Em hết tình lại chẳng bảo một câu` },
        { start: 134, end: 136, text: `Mòn mỏi trông đến ngày hai ta sánh bước` },
        { start: 136, end: 138, text: `Anh vẫn chú rể sao em không phải cô dâu` },
        { start: 138, end: 140, text: `Dẫu biết sức sống cũng chả còn` },
        { start: 140, end: 141, text: `Anh vẫn chờ cành cây trở lại xanh` },
        { start: 141, end: 143, text: `Em cứ hái và mang hết đi quả ngọt` },
        { start: 143, end: 144, text: `Còn trái đắng thôi thì gửi lại anh` },
        { start: 144, end: 148, text: `Người có còn đi qua từng góc phố?` },
        { start: 148, end: 152, text: `Người có còn yêu bao phút giây hẹn hò?` },
        { start: 152, end: 156, text: `Còn sợ mỗi tối khi đông gió về?` },
        { start: 156, end: 159, text: `Chờ em, em tới ôm anh thật lâu` },
        { start: 159, end: 163, text: `Từng phút từng giây yêu thương lìa xa` },
        { start: 163, end: 167, text: `Giọt nước mắt anh sao đớn đau lòng quá` },
        { start: 167, end: 171, text: `Tạm biệt hạnh phúc trao nhau hồi nào` },
        { start: 171, end: 174, text: `Tạm biệt chàng trai em đã từng yêu` },
        { start: 174, end: 178, text: `Em đã từng rất yêu` },
        { start: 178, end: 182, text: `Người có còn đi qua từng góc phố?` },
        { start: 182, end: 185, text: `Người có còn yêu bao phút giây hẹn hò?` },
        { start: 185, end: 189, text: `Còn sợ mỗi tối khi đông gió về?` },
        { start: 189, end: 194, text: `Chờ em, em tới ôm anh thật lâu` },
        { start: 194, end: 198, text: `Từng phút từng giây yêu thương lìa xa` },
        { start: 198, end: 202, text: `Giọt nước mắt anh sao đớn đau lòng quá` },
        { start: 202, end: 206, text: `Tạm biệt hạnh phúc trao nhau hồi nào` },
        { start: 206, end: 211, text: `Tạm biệt chàng trai em đã từng yêu` },
        { start: 211, end: 218, text: `Em đã từng rất yêu` },
    ],
};

export default CHILL_HITS_LYRICS;
